import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  nameText: {
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  emailText: {
    width: "35%",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "flex",
      alignItems: "baseline",
    },
  },
  labelSpan: {
    color: "#092958",
    fontSize: "0.75rem",
    fontFamily: "Roboto,sans-serif",
    fontWeight: 700,
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  idText: {
    width: "15%",
    display: "flex",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
      alignItems: "baseline",
      display: "flex",
    },
  },
  button: {
    width: "20%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
    },
  },
  checkBox: {
    width: "13%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      width: "15%",
    },
  },
}))

export default styles
